import { inject, Pipe, PipeTransform } from '@angular/core';
import { ProductionStatus } from '../../modules/mng/production-statuses/production-statuses.types';
import { ProductionStatusBadgeService } from '../components/production-status/production-status-badge.service';

@Pipe({
    standalone: true,
    name: 'productionStatusArray',
})
export class ProductionStatusArrayPipe implements PipeTransform {
    productionStatusBadgeService = inject(ProductionStatusBadgeService);

    // A sample list of production statuses.
    private productionStatuses: ProductionStatus[] =
        this.productionStatusBadgeService.getCache('work_order');

    transform(options: any[]): any[] {
        if (!options || !Array.isArray(options)) {
            return options;
        }

        return options.map((option) => {
            // If the option's value is a number, attempt to find a matching production status.
            if (option && typeof option.value === 'number') {
                const status = this.productionStatuses.find(
                    (s) => s.status_id === option.value
                );
                if (status) {
                    // Return a new option object with the value replaced by the production status name.
                    return { ...option, value: status.name };
                }
            }
            // If no transformation is needed, return the option as is.
            return option;
        });
    }
}
